import { api } from './index';

export const postFeedback = (data, token) =>
  api.post('jobs/feedback', data, {
    headers: { Authorization: token }
  });

export default {
  postFeedback
};
